import { useEffect, useState, useRef } from "react";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";

import Loading from "../../../components/Loading";
import Menu from "../../../components/Menu";
import api from "../../../services/api";
import { InputNumber } from "primereact/inputnumber";
import { MultiSelect } from "primereact/multiselect";

export function MetragemPeriodo() {
    const [artigos, setArtigos] = useState([]);
    const [data, setData] = useState([]);
    const [form, setForm] = useState({
        id: null,
        artigo: "",
        metragem: "",
        data_inicial: new Date(),
        data_final: new Date(),
        tipo: "1"
    });
    const [tipos, setTipos] = useState([]);

    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    const [initialDate, setInitialDate] = useState(null);
    const [finalDate, setFinalDate] = useState(null);

    const toast = useRef();

    const showError = (error) => toast.current.show({ summary: 'Ocorreu um Erro', severity: 'error', detail: error.response ? error.response.data.message : error.message });
    const showSuccess = (response) => toast.current.show({ summary: 'Sucesso', severity: 'success', detail: response.data.message });

    const format = (rowData, props) => {
        return Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 }).format(rowData[props.field]);
    }

    const fetchData = _ => {
        setIsLoading(true);
        if (initialDate !== null && finalDate !== null) {
            let data_inicial = initialDate.getFullYear() + '-' + (initialDate.getMonth() + 1) + '-' + initialDate.getDate();
            let data_final = finalDate.getFullYear() + '-' + (finalDate.getMonth() + 1) + '-' + finalDate.getDate();

            api.get("cadastros/metragem-periodo", {
                params: {
                    data_inicial: data_inicial,
                    data_final: data_final,
                    tipos: tipos
                }
            }).then((response) => {
                setArtigos(response.data.artigos);
                setData(response.data.dados);

                setIsLoading(false);
            }).catch((error) => {
                setIsLoading(false);
                showError(error);
            });
        } else {
            api.get("cadastros/metragem-periodo").then((response) => {
                setArtigos(response.data.artigos);
                setData(response.data.dados);

                setIsLoading(false);
            }).catch((error) => {
                setIsLoading(false);
                showError(error);
            });
        }
    }

    function handleSubmit() {
        if (form.data_inicial !== null && form.data_final !== null) {
            form.data_inicialf = form.data_inicial.getFullYear() + '-' + (form.data_inicial.getMonth() + 1) + '-' + form.data_inicial.getDate();
            form.data_finalf = form.data_final.getFullYear() + '-' + (form.data_final.getMonth() + 1) + '-' + form.data_final.getDate();
        }

        if (isEditing && form.id !== null) {
            setIsLoading(true);
            api.put(`cadastros/metragem-periodo/${form.id}/update`, {
                "artigo": form.artigo,
                "metragem": form.metragem,
                "data_inicial": form.data_inicialf,
                "data_final": form.data_finalf,
                "tipo": form.tipo
            }).then((response) => {
                fetchData();
                setIsEditing(false);
                setIsLoading(false);

                showSuccess(response);
            }).catch((error) => {
                setIsLoading(false);
                showError(error);
            });
        } else {
            setIsLoading(true);
            api.post(`cadastros/metragem-periodo`, {
                "artigo": form.artigo,
                "metragem": form.metragem,
                "data_inicial": form.data_inicialf,
                "data_final": form.data_finalf,
                "tipo": form.tipo
            }).then((response) => {
                fetchData(); 
                setIsLoading(false);
                showSuccess(response);
            }).catch((error) => {
                setIsLoading(false);
                showError(error);
            })
        }
    }

    function handleEdit(rowData) {
        setIsEditing(true);
        setIsVisible(true);

        let data_inicial = new Date(rowData.data_inicial.replace('-', '/'));
        let data_final = new Date(rowData.data_final.replace('-', '/'));

        setForm({
            id: rowData.id,
            artigo: rowData.artigo,
            metragem: rowData.metragem,
            data_inicial: data_inicial,
            data_final: data_final
        });
    }

    function handleDelete(rowData) {
        confirmDialog({
            acceptClassName: "p-button-danger",
            acceptLabel: "Excluir",
            rejectClassName: "p-button-secondary",
            rejectLabel: "Cancelar",
            header: "Excluir",
            message: "Você tem certeza que deseja excluir esse registro?",
            accept: () => {
                setIsLoading(true);
                api.delete(`cadastros/metragem-periodo/${rowData.id}/delete`).then((response) => {
                    fetchData();
                    setIsLoading(false);
                    showSuccess(response);
                }).catch((error) => {
                    fetchData();
                    setIsLoading(false);
                    showError(error);
                });
            }
        });
    }

    function onHide() {
        setIsEditing(false);
        setIsVisible(false);
        setForm({
            id: null,
            artigo: "",
            metragem: "",
            data_inicial: new Date(),
            data_final: new Date()
        });
    }

    function onShow() {
        setIsVisible(true);
    }

    useEffect(() => {
        fetchData();
    }, []);

    if (isLoading) {
        return <Loading />
    }

    return (
        <div>
            <Toast ref={toast} />
            <Menu />
            <Card
                className="p-m-1"
                title="Lançamento de Metragem por Período"
            >
                <Dialog
                    header={isEditing ? "Editar" : "Cadastrar"}
                    onHide={onHide}
                    style={{ minWidth: "30vw" }}
                    visible={isVisible}
                >
                    <div className="p-fluid">
                        <div className="p-field">
                            <label htmlFor="artigo">Artigo</label>
                            <Dropdown
                                className="p-m-1"
                                filter
                                onChange={e => setForm({ ...form, artigo: e.value })}
                                options={artigos}
                                optionLabel="codigo"
                                optionValue="codigo"
                                placeholder="Escolha um dos artigos"
                                value={form.artigo}
                            />
                        </div>
                        <div className="p-field">
                            <label htmlFor="metragem">Metragem: </label>
                            <InputNumber
                                className="p-m-1"
                                onChange={e => setForm({ ...form, metragem: e.value })}
                                placeholder="Digite a metragem"
                                value={form.metragem}
                            />
                        </div>
                        <div className="p-field">
                            <label htmlFor="">Tipo: </label>
                            <Dropdown
                                onChange={e => setForm({...form, tipo: e.value })}
                                options={[
                                    { label: 'PCP', value: '1' },
                                    { label: 'Planejado', value: '2' }
                                ]}
                                placeholder="Selecione o tipo..."
                                value={form.tipo}
                            />
                        </div>                        
                        <div className="p-field">
                            <label htmlFor="data_inicial">Data Inicial: </label>
                            <Calendar
                                className="p-m-1"
                                dateFormat="dd/mm/yy"
                                mask="99/99/9999"
                                onChange={e => setForm({ ...form, data_inicial: e.value })}
                                placeholder="Escolha a Data Inicial"
                                value={form.data_inicial}
                            />
                        </div>
                        <div className="p-field">
                            <label htmlFor="data_final">Data Final: </label>
                            <Calendar
                                className="p-m-1"
                                dateFormat="dd/mm/yy"
                                mask="99/99/9999"
                                onChange={e => setForm({ ...form, data_final: e.value })}
                                placeholder="Escolha a Data Final"
                                value={form.data_final}
                            />
                        </div>
                        <div className="p-d-flex p-flex-row">
                            <Button className="p-mr-6 p-button-secondary" label="Cancelar" onClick={onHide} />
                            <Button className="p-button-success" label="Salvar" onClick={handleSubmit} />
                        </div>
                    </div>
                </Dialog>

                <div className="p-d-flex p-flex-row p-jc-between">
                    <div>
                        <Calendar
                            className="p-m-1"
                            dateFormat="dd/mm/yy"
                            mask="99/99/9999"
                            onChange={e => setInitialDate(e.value)}
                            placeholder="Escolha a Data Inicial"
                            value={initialDate}
                        />
                        <Calendar
                            className="p-m-1"
                            dateFormat="dd/mm/yy"
                            mask="99/99/9999"
                            onChange={e => setFinalDate(e.value)}
                            placeholder="Escolha a Data Final"
                            value={finalDate}
                        />
                        <MultiSelect
                            className="p-m-1"
                            onChange={e => setTipos(e.value)}
                            options={[
                                { label: 'PCP', value: '1' },
                                { label: 'Planejado', value: '2' }
                            ]}
                            placeholder="Selecione os tipos"
                            value={tipos}
                        />
                        <Button 
                            className="p-m-1"
                            icon="pi pi-search"
                            onClick={fetchData}
                            title="Clique para concluir a pesquisa entre um período"
                        />
                    </div>
                    <Button
                        className="p-m-2"
                        icon="pi pi-plus"
                        onClick={() => onShow()}
                        title="Clique para cadastrar"
                    />
                </div>

                <DataTable
                    className="p-m-1"
                    emptyMessage="Nenhum registro encontrado"
                    size="small"
                    value={data}
                >
                    <Column header="Artigo" field="artigo" sortable />
                    <Column header="Metragem" field="metragem" sortable body={format} />
                    <Column header="Tipo" field="tipo" body={(rowData) => {
                        if(rowData.tipo === "1") {
                            return "PCP";
                        } else {
                            return "Planejado";
                        }
                    }} />
                    <Column header="Mínimo" field="metragem_minima" sortable body={format} />
                    <Column header="Data Inicial" field="datainicialf" />
                    <Column header="Data Final" field="datafinalf" />
                    <Column header="Ações" body={(rowData) => (
                        <div>
                            <Button
                                className="p-button-primary p-m-1"
                                icon="pi pi-pencil"
                                onClick={() => handleEdit(rowData)}
                                title="Clique para editar esse registro"
                            />
                            <Button
                                className="p-button-danger p-m-1"
                                icon="pi pi-trash"
                                onClick={() => handleDelete(rowData)}
                                title="Clique para excluir esse registro"
                            />
                        </div>
                    )} />
                </DataTable>
            </Card>
        </div>
    )
}